import * as React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  submitLeadURL,
  getJobDetails,
  getCompany,
} from '../../data/jobs/jobActions';
import {
  createDidError,
  createIsLoading,
} from '../../data/requests/requestsSelectors';
import { createJobSelector } from '../../data/jobs/jobSelectors';
import { createOpenWebJobSelector } from '../../data/owp/owpSelectors';
import { Button, Toolbar } from '../static/Elements';
import { Loading, Error } from '../static/Indicators';
import Header from '../static/Header';
import 'react-datepicker/dist/react-datepicker.css';
import Icon from '../static/Icons';
import renderHTML from 'react-render-html';

import createLogger from '../../utils/createLogger';

const DEBUG = true;
const debug = createLogger(DEBUG, `JobDetails.js`);

class JobDetail extends React.Component {
  constructor (props) {
    super (props);
  }

  static role = `detail`;
  static dependencies = [
    `GET_JOB`,
    `PUT_JOB`,
    `GET_OPENWEB_JOB`,
    `PUT_OPENWEB_JOB`,
  ];

  static propTypes = {
    id: PropTypes.string.isRequired,
    job: PropTypes.object,
    close: PropTypes.func.isRequired,
    didError: PropTypes.bool,
    isLoading: PropTypes.bool,
    submitLeadURL: PropTypes.func,
    onRemove: PropTypes.func.isRequired,
    owp: PropTypes.bool,
    selectContact: PropTypes.func,
  };

  componentDidMount () {
    const {updateState} = this;
    updateState ();
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const {updateState} = this;
    updateState ();
  };

  updateState = () => {
    const {job, jobData, onInputChange, owp} = this.props;
    if (job === undefined) return;
    debug.log ('Checking on :', job, jobData);
    if (owp && !jobData.initialized) {
      onInputChange ('initialized') (true);
      ['min_salary', 'max_salary', 'min_experience', 'max_experience'].forEach (field => {
        debug.log (`updateDate: checking ${field} -- ${job[field]} -- ${jobData[field]}`);
        if (!!job[field] && jobData[field] === '') {
          onInputChange (field) (`${job[field]}`);
        }
      })
    }
  };

  /* ------------ event handlers ------------ */
  onSubmitURL = (input) => {
    const {id, submitLeadURL, close} = this.props;
    submitLeadURL (id, input, close);
  };

  onInputChange = (field) => (input) => {
    console.log (input);
    this.setState ({...this.state, [field]: input});
  };

  /* ------------ render methods ------------ */
  render () {
    const {
      job,
      didError,
      isLoading,
      onRemove,
      owp,
      markStrategyFailure,
    } = this.props;

    debug.enter (`render`);
    debug.log (`  job:`, job);
    debug.log (`  didError: ${didError}`);
    debug.log (`  isLoading: ${isLoading}`);

    if (job === undefined) {
      return (
        <article className="details">
          <Error message="Job details not available"/>
        </article>
      )
    }

    if (isLoading || didError) {
      return (
        <article className="details">
          {didError
            ? <Error message="Error loading job post details"/>
            : <Loading/>}
        </article>
      )
    }

    const description = htmlify (job.description);
    const {title, id, company, location, posted} = job;
    const posted_date = posted ? new Date(posted).toUTCString().substr(5, 11) : null;
    if (owp !== undefined) {
      return (
        <article className="job-detail">
          <div className='detail-header'>
            <Header smallHeader={true} title={title}>
              {company} <br/>
              {location} <br/>
              Posted {posted_date} <br/>
            </Header>
            <Button danger onClick={onRemove}
                    key={`remove-job-${id}`}>
              <Icon.Trash/>Dismiss
            </Button>
          </div>
          <section>
            {renderHTML (description)}
          </section>

        </article>
      )
    } else {
      return (
        <article className="job-detail">
          <div className={'detail-header'}>
            <Header smallHeader={true} title={title}>
              {company} <br/>
              {location} <br/>
              Posted {posted_date} <br/>
            </Header>
            <div className='header-actions'>
              <Button onClick={markStrategyFailure}
                      key={`mark-job-${id}`}>
                Found Manually
              </Button>
              <Button danger onClick={onRemove}
                      key={`remove-job-${id}`}>
                Dismiss
              </Button>
            </div>
          </div>
          <section>
            { renderHTML(description) }
          </section>
        </article>
      );
    }
  }
}

/* ------------ static helpers ------------ */
const htmlify = (rawText) => {
  let html = `<p>`.concat(rawText, `</p>`);
  return html.replace(/(?:\r\n|\r|\n)/g, '<br/>');
};


/* ------------ redux connect ------------ */
const mapStateToProps = (state, ownProps) => {
  const jobSelector = createJobSelector(ownProps.id);
  const isLoading = createIsLoading(JobDetail.dependencies);
  const didError = createDidError(JobDetail.dependencies);
  const owpJobSelector = createOpenWebJobSelector(ownProps.id);

  return {
    job: owpJobSelector(state) || jobSelector(state),
    didError: didError(state),
    isLoading: isLoading(state),
  }
};

export default connect(mapStateToProps, {
  submitLeadURL,
  getJobDetails,
})(JobDetail);





// WEBPACK FOOTER //
// ./src/components/AgencyPostings/JobDetail.js